export default class LayoutSelectable {
  constructor(element) {
    $(element)
      .find('.js-selectable')
      .select2()
  }
}
